import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import StepperBreadcrumb from '../../../common/StepperBreadcrumb';
import {
  Stepper,
  Step,
  ShoppingCartIcon,
  FulfillmentDeliveryIcon,
  CreditCreditIcon
} from 'cat-ecommerce-alloy';
import { useLocation } from 'react-router-dom';
import {
  ORDERS_CHECKOUT_VIEW_ROUTE,
  REST_ORDERITEM_UPDATE_ROUTE,
  REST_ORDER_CALCULATE_ROUTE,
  SHOPPING_CART_ROUTE,
  PICKUP_AND_DELIVERY_PAGE,
  SUMMARY_AND_PAYMENT_ROUTE_LEGACY
} from '../../../../constants/routes';
import { useTranslation } from 'react-i18next';
import { getPaymentSummaryHeading } from '../../summary-and-payment/utils';
import { PCC_PS_TITLE_UPDATES } from '@app/constants/featureFlags';
import cx from 'classnames';

const CheckoutStepper = ({ cartURL = '' }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const pickUpAndDeliveryURL = `${PICKUP_AND_DELIVERY_PAGE}`; // modern page url
  const isPCCPaymentAndSummaryTitleUpdates = useSelector(
    state => state?.featureFlag?.[PCC_PS_TITLE_UPDATES]
  );

  const paymentSummaryHeading = getPaymentSummaryHeading(
    t,
    isPCCPaymentAndSummaryTitleUpdates
  );

  const activeMap = {
    [`${SHOPPING_CART_ROUTE}`]: 0,
    [`${REST_ORDERITEM_UPDATE_ROUTE}`]: 0,
    [`${REST_ORDER_CALCULATE_ROUTE}`]: 0,
    [`${ORDERS_CHECKOUT_VIEW_ROUTE}`]: 0,
    [`/${PICKUP_AND_DELIVERY_PAGE}`]: 1,
    [`${SUMMARY_AND_PAYMENT_ROUTE_LEGACY}`]: 2
  };
  const isPickupActive = activeMap[location.pathname] === 1;

  return (
    <div
      className={cx('row mx-0 d-print-none', {
        'mt-4': !isPCCPaymentAndSummaryTitleUpdates,
        'mt-3 mt-md-4': isPCCPaymentAndSummaryTitleUpdates
      })}
    >
      <Stepper
        activeStep={activeMap[location.pathname]}
        data-testid="checkout-stepper"
        className={cx('w-100', {
          'px-0 px-md-3': isPCCPaymentAndSummaryTitleUpdates
        })}
      >
        <Step>
          <StepperBreadcrumb href={cartURL} icon={ShoppingCartIcon}>
            {t('BCT_SHOPPING_CART')}
          </StepperBreadcrumb>
        </Step>
        <Step>
          <StepperBreadcrumb
            href={`${pickUpAndDeliveryURL}${location.search}`}
            icon={FulfillmentDeliveryIcon}
          >
            {t('PICKUP_DELIVERY_SHORT')}
          </StepperBreadcrumb>
        </Step>
        <Step>
          <StepperBreadcrumb
            icon={CreditCreditIcon}
            isContentDisabled={isPickupActive}
          >
            {paymentSummaryHeading}
          </StepperBreadcrumb>
        </Step>
      </Stepper>
    </div>
  );
};

export default CheckoutStepper;

CheckoutStepper.propTypes = {
  cartURL: PropTypes.string.isRequired
};
